const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const View = require('./view');
const Model = require('./model');

module.exports = createWidgetFactory({
    name: 'dp_error_management',
    viewClass: View,
    modelClass: Model,
    methods: {
        open(...args) {
            this.model.update(...args);
            this.toggleOpenClose(true);
            this.trackingDisplayedEvent();
        },

        close() {
            this.toggleOpenClose(false);
        },
    },
});
